import { render, staticRenderFns } from "./Register-Recruiter.vue?vue&type=template&id=2f837954&scoped=true&"
import script from "./Register-Recruiter.vue?vue&type=script&lang=js&"
export * from "./Register-Recruiter.vue?vue&type=script&lang=js&"
import style0 from "./Register-Recruiter.vue?vue&type=style&index=0&id=2f837954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f837954",
  null
  
)

export default component.exports